import React, { Component } from 'react';
import {RequestMoreInfo} from './RequestMoreInfo';
import ReactGA from 'react-ga';

export class SendEmail extends Component {
    componentDidMount() {
        ReactGA.set({ page: 'SendEmail' });
        ReactGA.pageview('/email');
    }

  render () {

    return (
      <div className="container pt-4">
        <h4 className="text-center">Send Email</h4>
        <div>
            <RequestMoreInfo listingId={''} forGeneralEmail={true}></RequestMoreInfo>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SendEmail.jsx